import React from "react";
import { WLFUserTable } from "../SA_UserPortfolios/wlf-user-table";
import { deep_copy } from "../../../lib/js-utils";
import SpinningLoaderOverlay from "../SpinningLoaderOverlay/SpinningLoaderOverlay";

class WLFUserPortfolios extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isSuperAdmin: false,
            sort_column: "Email",
            sort_descending: true,
            isLoading: false
        }
    }

    // can ignore maybe_render_wlf_popup which consists of...
    // maybe_render_wlf_popup
    // render_popup

    // can ignore AddUserModal
    // can ignore AddUserErrorModal
    // can ignore Actions

    // render_all_checkbox
    // render_headers
    // <RenderEdit />
    // component.state.sort_column
    // component.state.descending
    // component.state.show_menu
    // component.onMouseRowClick()(index, ev)
    // maybe_render_popup
    // maybe_render_admin_dev_popup
    // component.onBalanceClick
    // component.onEngageCashClick
    // render_acct_checkbox
    // component.state.selected_row
    // component.state.download_billing
    // do_sort(component, data, sort_by)
    // component.state.selected

    maybeLoad = async () => {
        try {
            this.setState({ isLoading: true });
            await this.props.maybeLoad();
        } catch (error) {
            console.log(error)
        } finally {
            this.setState({ isLoading: false });
        }
        
    }

    setTableRowLut = (table_lut) => {
        this.table_row_lut = deep_copy(table_lut);
    }
    render() {
        return (
            <div>
                {this.state.isLoading && <SpinningLoaderOverlay size={"2rem"} />}
                <WLFUserTable 
                    component={this}
                    wlf_item={this.props.wlf_item}
                    token={this.props.token}
                />
            </div>
        )
    }
}

export default WLFUserPortfolios;